<template>
  <control-base
    :config="conf"
    :dataType="dataType"
    :parentName="$options.name"
    @loaded="$emit('loaded', $event)"
    ref="base"
  >
    <template v-slot:filters>
      <p>Text</p>
      <input type="text" :value="conf.text" @change="changeLabelText" />

      <p>Background Colour</p>
      <input
        type="text"
        :value="conf.backgroundColour"
        @change="changeBgColour"
      />

      <p>Text Colour</p>
      <input type="text" :value="conf.textColour" @change="changeTextColour" />
    </template>
    <template v-slot:control>
      <div
        class="label"
        :style="{
          backgroundColor: conf.backgroundColour,
          color: conf.textColour,
        }"
      >
        <p>{{ config.text }}</p>
      </div>
    </template>
  </control-base>
</template>

<script>
export default {
  name: "Label",

  props: {
    config: {
      required: true,
      value: Object,
    },
  },

  data() {
    return {
      dataType: "campaign",
    };
  },

  computed: {
    conf() {
      return this.config;
    },

    layoutLocked() {
      return this.$store.getters.locked;
    },
  },

  methods: {
    changeBgColour(change) {
      this.conf.backgroundColour = change.srcElement.value;
      this.$emit("configChange", this.conf);
    },
    changeTextColour(change) {
      this.conf.textColour = change.srcElement.value;
      this.$emit("configChange", this.conf);
    },
    changeLabelText(change) {
      this.conf.text = change.srcElement.value;
      this.$emit("configChange", this.conf);
    },
  },
};
</script>

<style scoped>
.label {
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  font-weight: 700;
  border-radius: inherit;
}
</style>